export const createCrew = {
    state: {
        crewsList: [],
        crewMembersList: [],
        pieceId: null,
        favouriteCrews: [],
        crewOptions: {},

        filter: {
            searchFilter: '',
            athletesSearchFilter: '',
            selectedSquads: [],

            // remove this
            boatSearch: '',
            selectedParticipants: [],
            selectedBoatTypes: [],
            selectedSides: []
        }
    },

    getters: {
        crewMembersList(state) {
            return state.crewMembersList;
        },

        favouriteCrews(state) {
            return state.favouriteCrews;
        },

        addCrewPieceId(state) {
            return state.pieceId;
        },

        addCrewSearchFilter(state) {
            return state.filter.searchFilter;
        },

        addCrewAthletesSearchFilter(state) {
            return state.filter.athletesSearchFilter;
        },

        createCrewFilter(state) {
            return state.filter;
        },

        createCrewSelectedParticipants(state) {
            return _.sortBy(state.filter.selectedParticipants, 'user.data.last_name');
        },

        createCrewSelectedSquads(state) {
            return _.sortBy(state.filter.selectedSquads, 'name');
        },

        createCrewSelectedBoatTypes(state) {
            return _.sortBy(state.filter.selectedBoatTypes, 'name');
        },

        createCrewSelectedSides(state) {
            return _.sortBy(state.filter.selectedSides, 'name');
        },

        createCrewBoatSearch(state) {
            return state.filter.boatSearch;
        },
        crewOptions(state) {
            return state.crewOptions;
        }
    },

    mutations: {
        setCreateCrewParticipants(state, data) {
            state.filter.sessionAttendanceParticipants = data;
        },

        setCreateCrewSelectedParticipants(state, data) {
            state.filter.selectedParticipants = data;
        },

        setCreateCrewSelectedSquads(state, data) {
            state.filter.selectedSquads = data;
        },

        setCreateCrewSelectedBoatTypes(state, data) {
            state.filter.selectedBoatTypes = data;
        },

        setCreateCrewSelectedSides(state, data) {
            state.filter.selectedSides = data;
        },

        setCreateCrewBoatSearch(state, data) {
            state.filter.boatSearch = data;
        },
        updateCrewOptions(state, data) {
            state.crewOptions = {
                weight: data.shift().data,
                age: data.shift().data,
                gender: data.shift().data
            };
        }
    },

    actions: {
        getCrewAgeOptions(context) {
            return context.dispatch('get', {
                url: api + 'age-options'
            });
        },

        getCrewGenderOptions(context) {
            return context.dispatch('get', {
                url: api + 'gender-options'
            });
        },

        getCrewGroupOptions(context) {
            return context.dispatch('get', {
                url: api + 'crew-group-options'
            });
        },

        getCrewWeightOptions(context) {
            return context.dispatch('get', {
                url: api + 'weight-options'
            });
        },

        getCrewStructures(context, payload) {
            return context.dispatch('get', {
                url: api + 'crew-structures',
                params: {
                    sport_id: payload ? payload.sportId : null
                }
            });
        },

        getFavouriteCrews(context, payload) {
            return context.dispatch('get', {
                url: api + 'favourite-crews',
                params: {
                    club_id: payload.club_id,
                    session_type: payload.sport_id,
                    limit: payload.limit,
                    include: 'crew_users.user:fields(id|first_name|last_name|full_name|picture)'
                }
            });
        },

        getRecentCrews(context, payload) {
            return context.dispatch('get', {
                url: api + 'recent-crews',
                params: {
                    club_id: payload.club_id,
                    session_type: payload.sport_id,
                    limit: payload.limit,
                    include: 'crew_users.user:fields(id|first_name|last_name|full_name|picture)'
                }
            });
        },

        createCrew(context, payload) {
            return context.dispatch('post', {
                url: api + 'create-crew',
                data: payload
            });
        },

        editCrew(context, payload) {
            return context.dispatch('post', {
                url: api + 'edit-crew',
                data: payload
            });
        },

        editCrews(context, payload) {
            return context.dispatch('post', {
                url: api + 'edit-crews',
                data: payload
            });
        },
        assignCrewToSessions(context, payload) {
            return context.dispatch('post', {
                url: api + 'assign-crews-to-sessions',
                data: payload
            });
        },

        assignAthletesToCrew(context, payload) {
            return context.dispatch('post', {
                url: api + 'assign-athletes-to-crew',
                data: payload
            });
        },

        assignAthleteResultsToCrew(context, payload) {
            return context.dispatch('post', {
                url: api + 'assign-athlete-results-to-crew',
                data: payload
            });
        },

        getSessionCrews(context, payload) {
            let include = _.has(payload, 'include') ? ',' + payload.include : '';
            let filters = _.has(payload, 'filters') ? '?' + payload.filters : '';

            return context.dispatch('get', {
                url: api + 'session/' + payload.id + filters,
                params: {
                    club_id: payload.club_id,
                    include: include
                }
            });
        },

        publishCrews(context, payload) {
            return context.dispatch('post', {
                url: api + 'update-session',
                data: { ...payload }
            });
        },

        getCrewOptions(context) {
            if (Object.keys(context.state.crewOptions).length) {
                // do not refresh if it's already in store
                return;
            }
            return Promise.all([
                context.dispatch('getCrewWeightOptions'),
                context.dispatch('getCrewAgeOptions'),
                context.dispatch('getCrewGenderOptions')
            ]).then(responses => {
                context.commit('updateCrewOptions', responses);
            });
        }
    }
};
